<div class="tw-flex tw-flex-col tw-gap-2 tw-rounded-lg">
<!-- font family dropdown list-->
<div class="tw-flex tw-items-center tw-gap-2 tw-mb-2 tw-border tw-border-dashed tw-border-[#c5cee0] tw-rounded-[8px] tw-py-3 tw-px-4 tw-bg-[#f8f9fc]" ngxTippy="Note: This will apply to all the text in the template" tooltipPosition="bottom">
  <label class="tw-text-sm tw-text-gray-600" >Font family</label>
  <app-dropdown 
    [dropdownOptions]="fontFamilyOptions"
    (optionClicked)="onFontFamilySelected($event)"
    [isField]="true"
    [widthInPX]="'200px'" style="width: 200px !important;"
  >
    <button
      type="button"
      class="tw-w-full tw-flex tw-items-center tw-justify-between tw-border tw-border-[#c5cee0] tw-rounded-md tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-gray-800"
    >
      <span [style.font-family]="fontFamily">{{ getSelectedFontFamilyLabel() }}</span>
      <span class="tw-text-xs tw-text-gray-500">▼</span>
    </button>
  </app-dropdown>
</div>

  <basic-input
    [control]="subjectControl"
    label="Email subject"
    [required]="true"
    [addValidationColors]="false"
    autocomplete="off"
  ></basic-input>

  <app-banner-upload-field
    [organizationId]="organizationId"
    [eventId]="eventId"
    [originalImageUrl]="invitationInfo?.image_url ?? null"
    label="Upload image"
    [hint]="isSuperAdmin ? 'Attach photos in PNG, JPG, JPEG, WEBP, BMP.' : 'Attach photos in PNG, JPG, JPEG, WEBP, BMP. (Aspect ratio: 12:5)'"
    [skipCrop]="isSuperAdmin"
    cropModalHeader="Crop invitation image"
    [attachToEvent]="false"
    [showIcon]="true"
    [control]="imageUrlControl"
    (valueChanged)="onBannerChanged($event)"
  ></app-banner-upload-field>

  <!-- Rich text editor for the invitation body -->
  <ngx-editor
    #editorRef
    [border]="true"
    [editorPadding]="true"
    [placeholder]="'Type your invitation message'"
    [invitationInfo]="invitationInfo"
    [lineHeight]="'1.7em'"
  >
  </ngx-editor>

  <!-- CTA buttons under the editor (Confirm / Decline) -->
  <div class="tw-flex tw-items-center tw-justify-center tw-gap-6 tw-px-4 tw-py-6">
    <div
      class="tw-relative tw-flex tw-h-[52px] tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-px-6 tw-py-3.5"
      [ngClass]="declineButton.hidden ? 'tw-w-[calc(50%-12px)] tw-flex-none' : 'tw-min-w-0 tw-flex-1'"
      [style.background-color]="confirmButton.backgroundColor"
      [style.color]="confirmButton.textColor"
      (mouseenter)="hoverTarget = 'confirm'"
      (mouseleave)="hoverTarget = null"
    >
      <input
        type="text"
        class="tw-w-full tw-bg-transparent tw-text-center tw-leading-[1.5] tw-outline-none"
        [value]="getButtonLabel('confirm')"
        [style.font-family]="fontFamily"
        [style.font-weight]="confirmButton.isBold ? '700' : '500'"
        [style.font-style]="confirmButton.isItalic ? 'italic' : 'normal'"
        [style.text-decoration]="confirmButton.isUnderline ? 'underline' : 'none'"
        [style.font-size]="confirmButton.fontSize || '16px'"
        (blur)="onButtonBlur('confirm', $event)"
      />
      <button
        type="button"
        class="tw-text-xs tw-absolute -tw-right-3.5 -tw-top-3.5 tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200 tw-cursor-pointer tw-opacity-0 tw-text-gray-600 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-300 tw-transition-all tw-duration-150"
        [ngClass]="{ 'tw-opacity-100 tw-visible': hoverTarget === 'confirm' || colorPopupFor === 'confirm' }"
        (click)="openColorPopup('confirm', $event)"
        title="Edit colors"
      >
        <span class="tw-text-xs" aria-hidden="true">⚙</span>
      </button>
      @if (declineButton.hidden) {
      <button
        type="button"
        class="tw-absolute tw-left-[calc(100%+16px)] tw-top-1/2 -tw-translate-y-1/2 tw-flex tw-items-center tw-justify-center tw-p-[18px] tw-rounded-lg tw-border tw-border-dashed tw-border-blue-600 tw-bg-blue-50 tw-cursor-pointer hover:tw-bg-blue-100 tw-w-[52px] tw-h-[52px]"
        (click)="setDeclineHidden(false, $event)"
        title="Add decline button"
        aria-label="Add decline button"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_700_12597)">
          <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="#1C64F2"/>
          </g>
          <defs>
          <clipPath id="clip0_700_12597">
          <rect width="16" height="16" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>
      }
      @if (colorPopupFor === 'confirm') {
      <div
        class="tw-absolute -tw-right-3.5 tw-bottom-[calc(100%+18px)] tw-z-20 tw-w-[140px] tw-rounded-lg tw-bg-gray-200 tw-p-2"
        (click)="$event.stopPropagation()"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2">
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-text-black tw-border tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-font-semibold hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': confirmButton.isBold }"
            (click)="toggleButtonTextStyle('confirm', 'bold', $event)"
            title="Bold"
          >
            <span class="tw-text-xs">B</span>
          </button>
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-text-black tw-border tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-italic hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': confirmButton.isItalic }"
            (click)="toggleButtonTextStyle('confirm', 'italic', $event)"
            title="Italic"
          >
            <span class="tw-text-xs">I</span>
          </button>
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-text-black tw-border tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-underline tw-decoration- hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': confirmButton.isUnderline }"
            (click)="toggleButtonTextStyle('confirm', 'underline', $event)"
            title="Underline"
          >
            <span class="tw-text-xs">U</span>
          </button>
        </div>
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Text color</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="confirmButton.textColor"
          />
        </div>
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Background</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="confirmButton.backgroundColor"
          />
        </div>
        <div class="tw-relative tw-mt-2">
          <button
            type="button"
            class="tw-w-full tw-flex tw-items-center tw-justify-between tw-bg-white tw-border tw-border-[#c5cee0] tw-rounded-md tw-px-2 tw-py-2 tw-text-sm tw-text-black"
            (click)="toggleButtonFontSizeMenu('confirm', $event)"
          >
            <span> {{ getButtonFontSizeLabel('confirm') }}@if (confirmButton.fontSize === '16px' || !confirmButton.fontSize) { <span class="tw-text-gray-500"></span> } </span>
            <span class="tw-text-xs tw-text-gray-500">▼</span>
          </button>
          @if (fontSizeMenuFor === 'confirm') {
          <div class="tw-absolute tw-left-0 tw-right-0 tw-top-full tw-mt-1 tw-text-black tw-bg-white tw-border tw-border-[#c5cee0] tw-rounded-md tw-shadow-lg tw-z-30">
            <button type="button" class="tw-w-full tw-text-[12px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('confirm', '14px', $event)">Small</button>
            <button type="button" class="tw-w-full tw-text-[14px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('confirm', '16px', $event)">Normal</button>
            <button type="button" class="tw-w-full tw-text-[16px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('confirm', '18px', $event)">Large</button>
          </div>
          }
        </div>
      </div>
      }
    </div>

    @if (!declineButton.hidden) {
    <div
      class="tw-relative tw-flex tw-h-[52px] tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-px-6 tw-py-3.5"
      [style.background-color]="declineButton.backgroundColor"
      [style.color]="declineButton.textColor"
      (mouseenter)="hoverTarget = 'decline'"
      (mouseleave)="hoverTarget = null"
    >
      <input
        type="text"
        class="tw-w-full tw-bg-transparent tw-text-center tw-leading-[1.5] tw-outline-none"
        [value]="getButtonLabel('decline')"
        [style.font-family]="fontFamily"
        [style.font-weight]="declineButton.isBold ? '700' : '500'"
        [style.font-style]="declineButton.isItalic ? 'italic' : 'normal'"
        [style.text-decoration]="declineButton.isUnderline ? 'underline' : 'none'"
        [style.font-size]="declineButton.fontSize || '16px'"
        (blur)="onButtonBlur('decline', $event)"
      />
      <button
        type="button"
        class="tw-text-xs tw-absolute -tw-right-3.5 -tw-top-3.5 tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200 tw-cursor-pointer tw-opacity-0 tw-text-gray-600 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-300 tw-transition-all tw-duration-150"
        [ngClass]="{ 'tw-opacity-100 tw-visible': hoverTarget === 'decline' || colorPopupFor === 'decline' }"
        (click)="openColorPopup('decline', $event)"
        title="Edit colors"
      >
        <span class="tw-text-xs" aria-hidden="true">⚙</span>
      </button>
      @if (colorPopupFor === 'decline') {
      <div
        class="tw-absolute -tw-right-3.5 tw-bottom-[calc(100%+18px)] tw-z-20 tw-w-[140px] tw-rounded-lg tw-bg-gray-200 tw-p-2"
        (click)="$event.stopPropagation()"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2">
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-border tw-text-black tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-font-semibold hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': declineButton.isBold }"
            (click)="toggleButtonTextStyle('decline', 'bold', $event)"
            title="Bold"
          >
            <span class="tw-text-xs ">B</span>
          </button>
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-border tw-text-black tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-italic hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': declineButton.isItalic }"
            (click)="toggleButtonTextStyle('decline', 'italic', $event)"
            title="Italic"
          >
            <span class="tw-text-xs ">I</span>
          </button>
          <button
            type="button"
            class="tw-flex-1 tw-py-1 tw-rounded-md tw-border tw-text-black tw-border-[#c5cee0] tw-bg-white tw-text-sm tw-underline hover:tw-bg-[#eef4ff]"
            [ngClass]="{ '!tw-bg-gray-400 !tw-text-white tw-border-[#1f6fe0]': declineButton.isUnderline }"
            (click)="toggleButtonTextStyle('decline', 'underline', $event)"
            title="Underline"
          >
            <span class="tw-text-xs ">U</span>
          </button>
        </div>
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Text color</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="declineButton.textColor"
          />
        </div>
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Background</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="declineButton.backgroundColor"
          />
        </div>
        <div class="tw-relative tw-mt-2">
          <button
            type="button"
            class="tw-w-full tw-flex tw-items-center tw-justify-between tw-bg-white tw-border tw-border-[#c5cee0] tw-rounded-md tw-px-2 tw-py-2 tw-text-sm tw-text-black"
            (click)="toggleButtonFontSizeMenu('decline', $event)"
          >
            <span> {{ getButtonFontSizeLabel('decline') }}@if (declineButton.fontSize === '16px' || !declineButton.fontSize) { <span class="tw-text-gray-500"></span> } </span>
            <span class="tw-text-xs tw-text-gray-500">▼</span>
          </button>
          @if (fontSizeMenuFor === 'decline') {
          <div class="tw-absolute tw-left-0 tw-right-0 tw-top-full tw-mt-1 tw-bg-white tw-border tw-text-black tw-border-[#c5cee0] tw-rounded-md tw-shadow-lg tw-z-30">
            <button type="button" class="tw-w-full tw-text-[12px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('decline', '14px', $event)">Small</button>
            <button type="button" class="tw-w-full tw-text-[14px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('decline', '16px', $event)">Normal</button>
            <button type="button" class="tw-w-full tw-text-[16px] tw-px-3 tw-py-2 hover:tw-bg-[#eef4ff]" (click)="selectButtonFontSize('decline', '18px', $event)">Large</button>
          </div>
          }
        </div>
        <button
          type="button"
          class="tw-mt-2 tw-flex tw-h-[22px] tw-items-center tw-gap-1 tw-rounded-md tw-p-0.5 tw-text-sm tw-font-medium tw-leading-[1.5] tw-text-red-600 tw-cursor-pointer"
          (click)="setDeclineHidden(true, $event)"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_700_12590)">
            <path d="M10.8908 2.52632H8.4464V1.26316C8.4464 0.928148 8.31763 0.606858 8.08842 0.36997C7.85921 0.133082 7.54833 0 7.22418 0H4.77973C4.45558 0 4.1447 0.133082 3.91549 0.36997C3.68628 0.606858 3.55751 0.928148 3.55751 1.26316V2.52632H1.11306C0.950987 2.52632 0.795549 2.59286 0.680943 2.7113C0.566338 2.82975 0.501953 2.99039 0.501953 3.15789C0.501953 3.3254 0.566338 3.48604 0.680943 3.60449C0.795549 3.72293 0.950987 3.78947 1.11306 3.78947H1.72418V10.7368C1.72418 11.0719 1.85294 11.3931 2.08216 11.63C2.31137 11.8669 2.62224 12 2.9464 12H9.05751C9.38166 12 9.69254 11.8669 9.92175 11.63C10.151 11.3931 10.2797 11.0719 10.2797 10.7368V3.78947H10.8908C11.0529 3.78947 11.2084 3.72293 11.323 3.60449C11.4376 3.48604 11.502 3.3254 11.502 3.15789C11.502 2.99039 11.4376 2.82975 11.323 2.7113C11.2084 2.59286 11.0529 2.52632 10.8908 2.52632ZM4.77973 1.26316H7.22418V2.52632H4.77973V1.26316ZM5.39084 9.47368C5.39084 9.64119 5.32646 9.80183 5.21185 9.92028C5.09725 10.0387 4.94181 10.1053 4.77973 10.1053C4.61765 10.1053 4.46222 10.0387 4.34761 9.92028C4.233 9.80183 4.16862 9.64119 4.16862 9.47368V5.05263C4.16862 4.88513 4.233 4.72448 4.34761 4.60604C4.46222 4.48759 4.61765 4.42105 4.77973 4.42105C4.94181 4.42105 5.09725 4.48759 5.21185 4.60604C5.32646 4.72448 5.39084 4.88513 5.39084 5.05263V9.47368ZM7.83529 9.47368C7.83529 9.64119 7.7709 9.80183 7.6563 9.92028C7.54169 10.0387 7.38625 10.1053 7.22418 10.1053C7.0621 10.1053 6.90666 10.0387 6.79205 9.92028C6.67745 9.80183 6.61306 9.64119 6.61306 9.47368V5.05263C6.61306 4.88513 6.67745 4.72448 6.79205 4.60604C6.90666 4.48759 7.0621 4.42105 7.22418 4.42105C7.38625 4.42105 7.54169 4.48759 7.6563 4.60604C7.7709 4.72448 7.83529 4.88513 7.83529 5.05263V9.47368Z" fill="#E02424"/>
            </g>
            <defs>
            <clipPath id="clip0_700_12590">
            <rect width="12" height="12" fill="white"/>
            </clipPath>
            </defs>
          </svg>          
          Remove
        </button>
      </div>
      }
    </div>
    }
  </div>
  @if (colorPopupFor) {
  <div class="tw-fixed tw-inset-0 tw-z-10" (click)="closeColorPopup()"></div>
  }

  <div class="tw-mb-3">
    <div
      class="tw-relative tw-h-12 tw-rounded-t-xl tw-px-4 tw-py-2"
      [style.background-color]="cardBackgroundColor || null"
      (mouseenter)="hoverTarget = 'card'"
      (mouseleave)="hoverTarget = null"
    >
      <img src="https://res.cloudinary.com/contactless/image/upload/v1618317771/uploaded_public_files/swq2m3hzq3lokmctrkjb.svg" alt="timing icon" />
      <button
        type="button"
        class="tw-text-xs tw-absolute tw-right-2 tw-top-2 tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200 tw-cursor-pointer tw-opacity-0 tw-text-gray-600 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-300 tw-transition-all tw-duration-150"
        [ngClass]="{ 'tw-opacity-100 tw-visible': hoverTarget === 'card' }"
        (click)="openColorPopup('card', $event)"
        title="Edit card background"
      >
        <span class="tw-text-xs" aria-hidden="true">⚙</span>
      </button>
      @if (colorPopupFor === 'card') {
      <div
        class="tw-absolute tw-bottom-full tw-right-0 tw-mb-8 tw-p-2 tw-rounded-2xl tw-shadow-2xl tw-bg-gray-200 tw-border-1 tw-border-blue-200 tw-rounded-8px tw-box-shadow-4px-12px-0-0-0-12px-rgba-0-0-0-0-12 tw-z-20 tw-min-w-180px"
        (click)="$event.stopPropagation()"
      >
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Background</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="cardBackgroundColor"
          />
        </div>
      </div>
      }
    </div>
    <div class="tw-box-border tw-rounded-b-xl tw-border tw-border-solid tw-border-[#d5ddeb] tw-p-4" [style.font-family]="fontFamily">
      <div class="tw-mb-3 tw-cursor-default tw-text-xl tw-font-bold tw-leading-6 tw-text-[rgba(9,12,16,0.87)]">
        {{ publicStartDay | date : 'dd MMM' }} - {{ publicEndDay | date : 'dd MMM' }}
      </div>
      <div class="tw-flex tw-flex-col tw-gap-3">
        @for (row of displayedEventTimings; track $index) {
        <div class="tw-grid tw-grid-cols-[84px_1fr] tw-gap-3.5 tw-items-stretch">
          <div
            class="tw-rounded-lg tw-p-2 tw-flex tw-flex-col tw-justify-center"
            [ngClass]="{
              'tw-bg-blue-600 tw-text-white': row.slots.length > 0,
              'tw-bg-gray-200 tw-text-gray-500': row.slots.length === 0
            }"
          >
            @if (row.day) {
            <div class="tw-text-inherit tw-font-bold tw-text-base">{{ row.day | date : 'EEE' }}</div>
            <div class="tw-text-inherit tw-text-base">{{ row.day | date : 'MMM d' }}</div>
            } @else {
            <div class="tw-text-inherit tw-text-sm">—</div>
            }
          </div>
          <div
            class="tw-px-6 tw-py-2 tw-min-h-16 tw-rounded-lg tw-w-full tw-flex tw-flex-col tw-justify-center"
            [ngClass]="{
              'tw-bg-gray-100': row.slots.length > 0,
              'tw-bg-gray-200': row.slots.length === 0
            }"
          >
            @if (row.slots.length > 0) {
            <div class="tw-flex tw-flex-wrap tw-gap-1 tw-items-center tw-font-medium tw-text-base">
              @for (slot of row.slots; track $index) {
              <div class="tw-flex tw-items-center tw-flex-nowrap">
                <span class="tw-whitespace-nowrap tw-shrink-0 tw-text-base tw-text-black">
                  {{ slot.from }}
                  @if (slot.to && slot.to !== slot.from) {
                  - {{ slot.to }}
                  }
                </span>
                @if (!$last) {
                <span class="tw-inline-block tw-h-6 tw-border-l tw-border-gray-400 tw-mx-3 tw-shrink-0" aria-hidden="true"></span>
                }
              </div>
              }
            </div>
            } @else {
            <div class="tw-italic tw-text-base tw-text-gray-500">No event activity on this day</div>
            }
            @if (row.info) {
            <div class="tw-italic tw-text-base tw-text-gray-500 tw-mt-1">{{ row.info }}</div>
            }
          </div>
        </div>
        }
      </div>
      <div class="tw-flex tw-justify-between tw-items-center tw-mt-1">
        <div>
          @if (showTimingsToggle) {
          <button
            type="button"
            class="tw-font-semibold tw-text-sm tw-text-blue-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
            (click)="toggleTimingsExpanded()"
          >
            @if (isTimingsExpanded) {
            Show less
            } @else {
            + {{ hiddenTimingsCount }} more days
            }
          </button>
          }
        </div>
        <div class="tw-relative tw-flex tw-justify-end tw-items-center tw-pt-2.5">
          <div
            class="tw-relative tw-inline-flex tw-cursor-default tw-items-center tw-gap-1.5 tw-font-semibold tw-text-sm tw-shrink-0"
            [style.color]="resolvedCalendarButtonColor"
            (mouseenter)="hoverTarget = 'calendar'"
            (mouseleave)="hoverTarget = null"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              [attr.fill]="resolvedCalendarButtonColor"
            >
              <path
                d="M0 14.4C0 14.8243 0.168571 15.2313 0.468629 15.5314C0.768687 15.8314 1.17565 16 1.6 16H14.4C14.8243 16 15.2313 15.8314 15.5314 15.5314C15.8314 15.2313 16 14.8243 16 14.4V6.4H0V14.4ZM11.2 8.4C11.2 8.29391 11.2421 8.19217 11.3172 8.11716C11.3922 8.04214 11.4939 8 11.6 8H12.4C12.5061 8 12.6078 8.04214 12.6828 8.11716C12.7579 8.19217 12.8 8.29391 12.8 8.4V9.2C12.8 9.30609 12.7579 9.40783 12.6828 9.48284C12.6078 9.55786 12.5061 9.6 12.4 9.6H11.6C11.4939 9.6 11.3922 9.55786 11.3172 9.48284C11.2421 9.40783 11.2 9.30609 11.2 9.2V8.4ZM11.2 11.6C11.2 11.4939 11.2421 11.3922 11.3172 11.3172C11.3922 11.2421 11.4939 11.2 11.6 11.2H12.4C12.5061 11.2 12.6078 11.2421 12.6828 11.3172C12.7579 11.3922 12.8 11.4939 12.8 11.6V12.4C12.8 12.5061 12.7579 12.6078 12.6828 12.6828C12.6078 12.7579 12.5061 12.8 12.4 12.8H11.6C11.4939 12.8 11.3922 12.7579 11.3172 12.6828C11.2421 12.6078 11.2 12.5061 11.2 12.4V11.6ZM7.2 8.4C7.2 8.29391 7.24214 8.19217 7.31716 8.11716C7.39217 8.04214 7.49391 8 7.6 8H8.4C8.50609 8 8.60783 8.04214 8.68284 8.11716C8.75786 8.19217 8.8 8.29391 8.8 8.4V9.2C8.8 9.30609 8.75786 9.40783 8.68284 9.48284C8.60783 9.55786 8.50609 9.6 8.4 9.6H7.6C7.49391 9.6 7.39217 9.55786 7.31716 9.48284C7.24214 9.40783 7.2 9.30609 7.2 9.2V8.4ZM7.2 11.6C7.2 11.4939 7.24214 11.3922 7.31716 11.3172C7.39217 11.2421 7.49391 11.2 7.6 11.2H8.4C8.50609 11.2 8.60783 11.2421 8.68284 11.3172C8.75786 11.3922 8.8 11.4939 8.8 11.6V12.4C8.8 12.5061 8.75786 12.6078 8.68284 12.6828C8.60783 12.7579 8.50609 12.8 8.4 12.8H7.6C7.49391 12.8 7.39217 12.7579 7.31716 12.6828C7.24214 12.6078 7.2 12.5061 7.2 12.4V11.6ZM3.2 8.4C3.2 8.29391 3.24214 8.19217 3.31716 8.11716C3.39217 8.04214 3.49391 8 3.6 8H4.4C4.50609 8 4.60783 8.04214 4.68284 8.11716C4.75786 8.19217 4.8 8.29391 4.8 8.4V9.2C4.8 9.30609 4.75786 9.40783 4.68284 9.48284C4.60783 9.55786 4.50609 9.6 4.4 9.6H3.6C3.49391 9.6 3.39217 9.55786 3.31716 9.48284C3.24214 9.40783 3.2 9.30609 3.2 9.2V8.4ZM3.2 11.6C3.2 11.4939 3.24214 11.3922 3.31716 11.3172C3.39217 11.2421 3.49391 11.2 3.6 11.2H4.4C4.50609 11.2 4.60783 11.2421 4.68284 11.3172C4.75786 11.3922 4.8 11.4939 4.8 11.6V12.4C4.8 12.5061 4.75786 12.6078 4.68284 12.6828C4.60783 12.7579 4.50609 12.8 4.4 12.8H3.6C3.49391 12.8 3.39217 12.7579 3.31716 12.6828C3.24214 12.6078 3.2 12.5061 3.2 12.4V11.6Z"
              />
              <path
                d="M16 3.2C16 2.77565 15.8314 2.36869 15.5314 2.06863C15.2313 1.76857 14.8243 1.6 14.4 1.6H12.8V0.8C12.8 0.587827 12.7157 0.384344 12.5657 0.234315C12.4157 0.0842854 12.2122 0 12 0C11.7878 0 11.5843 0.0842854 11.4343 0.234315C11.2843 0.384344 11.2 0.587827 11.2 0.8V1.6H8.8V0.8C8.8 0.587827 8.71571 0.384344 8.56569 0.234315C8.41566 0.0842854 8.21217 0 8 0C7.78783 0 7.58434 0.0842854 7.43431 0.234315C7.28429 0.384344 7.2 0.587827 7.2 0.8V1.6H4.8V0.8C4.8 0.587827 4.71571 0.384344 4.56569 0.234315C4.41566 0.0842854 4.21217 0 4 0C3.78783 0 3.58434 0.0842854 3.43431 0.234315C3.28429 0.384344 3.2 0.587827 3.2 0.8V1.6H1.6C1.17565 1.6 0.768687 1.76857 0.468629 2.06863C0.168571 2.36869 0 2.77565 0 3.2V4.8H16V3.2Z"
              />
            </svg>
            <span>Add to Calendar</span>
            <button
              type="button"
              class="tw-text-xs tw-absolute tw-right-[-12px] tw-top-[-12px] tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200 tw-cursor-pointer tw-opacity-0 tw-text-gray-600 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-300 tw-transition-all tw-duration-150"
              [ngClass]="{ 'tw-opacity-100 tw-visible': hoverTarget === 'calendar' }"
              (click)="openColorPopup('calendar', $event)"
              title="Edit link color"
            >
              <span class="tw-text-xs" aria-hidden="true">⚙</span>
            </button>
            @if (colorPopupFor === 'calendar') {
            <div
              class="tw-absolute tw-bottom-full tw-right-0 tw-mb-8 tw-p-2 tw-rounded-2xl tw-shadow-2xl tw-bg-gray-200 tw-border-1 tw-border-blue-200 tw-rounded-8px tw-box-shadow-4px-12px-0-0-0-12px-rgba-0-0-0-0-12 tw-z-20 tw-min-w-180px"
              (click)="$event.stopPropagation()"
            >
              <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
                <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Color</label>
                <input
                  type="color"
                  class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
                  [(ngModel)]="calendarButtonColor"
                />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (staticMapUrl || venueName || venueAddress) {
  <div class="tw-mb-3">
    <div
      class="tw-relative tw-h-12 tw-rounded-t-xl tw-px-4 tw-py-2"
      [style.background-color]="cardBackgroundColor || null"
      (mouseenter)="hoverTarget = 'location'"
      (mouseleave)="hoverTarget = null"
    >
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 2.5C11.3056 2.5 7.5 6.30558 7.5 11C7.5 17.375 16 29.5 16 29.5C16 29.5 24.5 17.375 24.5 11C24.5 6.30558 20.6944 2.5 16 2.5ZM16 14.5C14.067 14.5 12.5 12.933 12.5 11C12.5 9.067 14.067 7.5 16 7.5C17.933 7.5 19.5 9.067 19.5 11C19.5 12.933 17.933 14.5 16 14.5Z"
          fill="white"
        />
      </svg>
      <button
        type="button"
        class="tw-text-xs tw-absolute tw-right-2 tw-top-2 tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200 tw-cursor-pointer tw-opacity-0 tw-text-gray-600 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-300 tw-transition-all tw-duration-150"
        [ngClass]="{ 'tw-opacity-100 tw-visible': hoverTarget === 'location' }"
        (click)="openColorPopup('location', $event)"
        title="Edit location header background"
      >
        <span class="tw-text-xs">⚙</span>
      </button>
      @if (colorPopupFor === 'location') {
      <div
        class="tw-absolute tw-bottom-full tw-right-0 tw-mb-8 tw-p-2 tw-rounded-2xl tw-shadow-2xl tw-bg-gray-200 tw-border-1 tw-border-blue-200 tw-rounded-8px tw-box-shadow-4px-12px-0-0-0-12px-rgba-0-0-0-0-12 tw-z-20 tw-min-w-180px"
        (click)="$event.stopPropagation()"
      >
        <div class="tw-mb-2.5 tw-flex tw-items-center tw-justify-between tw-gap-2.5 last:tw-mb-0">
          <label class="tw-text-[13px] tw-text-[rgba(38,47,54,0.87)]">Background</label>
          <input
            type="color"
            class="tw-h-7 tw-w-9 tw-cursor-pointer tw-rounded tw-border tw-border-solid tw-border-[#c5cee0] tw-bg-white tw-p-0.5"
            [(ngModel)]="cardBackgroundColor"
          />
        </div>
      </div>
      }
    </div>
    <div class="tw-box-border tw-rounded-b-xl tw-border tw-border-solid tw-border-[#d5ddeb] tw-p-4" [style.font-family]="fontFamily">
      @if (staticMapUrl) {
      <img class="tw-mb-3 tw-block tw-w-full tw-max-h-[240px] tw-rounded-md tw-object-cover" [src]="staticMapUrl" alt="Event location map" />
      }
      @if (venueName) {
      <div class="tw-cursor-default tw-text-base tw-font-semibold tw-leading-6 tw-text-[rgba(9,12,16,0.87)]">{{ venueName }}</div>
      }
      @if (venueAddress) {
      <div class="tw-cursor-default tw-text-sm tw-font-normal tw-leading-5 tw-text-[rgba(38,47,54,0.75)]">{{ venueAddress }}</div>
      }
    </div>
  </div>
  }
</div>
